export default __webpack_public_path__ + "static/media/AG3.fa877f42.jpg";